import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ScrollListenerService {
  private scrollTop = 0;
  onScrollChangeRequest = new Subject<number>();
  constructor() {}

  setCurrentScrollTop(scrollTop: number) {
    this.scrollTop = scrollTop;
  }
  getCurrentScrollTop(): number {
    return this.scrollTop;
  }

  setScrollTop(scrollTop: number) {
    this.onScrollChangeRequest.next(scrollTop);
  }
}
